export default __webpack_public_path__ + "static/media/tete7.b607c866.png";